export default __webpack_public_path__ + "static/media/practice-test-10.6f65985e.csv";